/**
 * src/components/ui/Pildora.jsx
 * Filtro rápido en forma de píldora, el de la línea de tiempo de Ejecuciones.
 *
 * Extraído el 28-08 (hilo de distribución) al ganar la tabla de churn sus
 * propios filtros: dos usos reales, un componente — la regla de no duplicar.
 */

export function Pildora({ activa, children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)',
        padding: 'var(--space-1) var(--space-3)',
        borderRadius: 'var(--radius-pill)',
        background: activa ? 'var(--color-accent-soft)' : 'var(--color-surface)',
        border: `1px solid ${activa ? 'transparent' : 'var(--color-border)'}`,
        color: activa ? 'var(--color-accent)' : 'var(--color-text-2)',
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  )
}
